export function useLoyalty() {
  // Read loyalty status from useState (initialized by plugin)
  // This is safe to call anywhere - no context issues
  const isLoyaltyUser = useState('is-loyalty-user');

  // Function to get loyalty email fresh from cookie (client-side only)
  const getLoyaltyEmail = () => {
    if (import.meta.server) return null;

    const rawCookie = document.cookie.split('; ').find((row) => row.startsWith('blackroll_loyalty='));

    if (!rawCookie) return null;

    try {
      const cookieValue = rawCookie.split('=')[1];
      const urlDecoded = decodeURIComponent(cookieValue);
      const binaryString = atob(urlDecoded);
      const bytes = Uint8Array.from(binaryString, (c) => c.charCodeAt(0));
      return new TextDecoder().decode(bytes);
    } catch (e) {
      console.error('Error decoding loyalty cookie:', e);
      return null;
    }
  };

  const loyaltyDiscount = (product) => {
    if (!product || !product.tags) return product;

    const firstDiscountTag = product.tags.find((tag) => tag.startsWith('loyalty_discount_'));

    if (!firstDiscountTag) return product;

    const discountValue = parseFloat(firstDiscountTag.replace('loyalty_discount_', ''));

    product.variants.edges = product.variants.edges.map(({ node }) => {
      const originalPrice = node.price;
      const discountedPrice = (parseFloat(originalPrice.amount) * (100 - discountValue)) / 100;

      return {
        node: {
          ...node,
          price: {
            amount: discountedPrice.toFixed(2),
            currencyCode: originalPrice.currencyCode,
            isLoyaltyDiscount: true,
          },
          compareAtPrice: originalPrice,
        },
      };
    });

    return product;
  };

  return {
    isLoyaltyUser,
    getLoyaltyEmail,
    loyaltyDiscount,
  };
}
